import { MetricClassCounts, Metrics } from "hooks/DetectorDetail/useTopLevelStats";

export function getTotalValue(metric: MetricClassCounts) {
  return Object.values(metric).reduce((total: number, m) => {
    if (typeof m === "number") {
      return total + m;
    }
    return total;
  }, 0);
}

export function getLowestGroundTruthClassCount(metrics?: Metrics) {
  const classNames = metrics?.summary.class_names ?? [];
  const classNameGroundTruthCounts = classNames.map(
    (className) => metrics?.summary?.class_counts?.cust_labeler?.[className] ?? 0
  );
  const lowestGroundTruthClassCount =
    classNameGroundTruthCounts.length > 0 ? Math.min(...classNameGroundTruthCounts) : 0;

  return lowestGroundTruthClassCount;
}
